import { render, staticRenderFns } from "./Playing.vue?vue&type=template&id=4c8e0ed8&"
import script from "./Playing.vue?vue&type=script&lang=ts&"
export * from "./Playing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports